import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export const SelectFilterMessage = () => {
  const { t } = useTranslation();

  return (
    <Typography variant="h6" sx={{ mt: 6, textAlign: "center", width: "100%" }}>
      {t("selectFiltersAndSubmit")}
    </Typography>
  );
};
